import {Grid, Typography, Paper} from '@material-ui/core';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import GenelcoBatchFileTable from './GenelcoBatchFileTable';
import './GenelcoBatchFileManagementPage.sass';
import {Scope} from 'Shared/constants/Scope';
import {FileExtension} from 'Shared/components/FileDownloadButton';
import ToolbarHeader, {ExportToolbarHeaderIcon} from 'Shared/components/Toolbar/ToolbarHeader';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import ModularHost from 'Shared/components/ModularHost/ModularHost';

import {
  changeGenelcoBatchFileFilters,
  clearGenelcoBatchFiles,
  clearGenelcoBatchFileSort,
  EmptyGenelcoBatchFileFilters,
  getGenelcoBatchFile,
} from 'Enrollment/ducks/genelcoBatchFileManagement';
import * as O from 'fp-ts/lib/Option';

export const hasAbilityToGenelcoBatchFileManagementPage = (scopes: Scope[]) =>
  scopes.some(scope => /et\.GenelcoBatchFileManagementPagefile\|(\*|2)/.test(scope));

const GenelcoBatchFileManagementPage = () => {
  const {genelcoBatchFileManagementPage, genelcoBatchFileFilters, sort} = useSelector(
    (state: ReducerState) => state.genelcoBatchFileManagementState
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getGenelcoBatchFile(undefined, genelcoBatchFileFilters, O.toUndefined(sort)));
  }, [dispatch, genelcoBatchFileFilters, sort]);

  useEffect(() => {
    dispatch(changeGenelcoBatchFileFilters(EmptyGenelcoBatchFileFilters));
    dispatch(clearGenelcoBatchFiles());
    dispatch(clearGenelcoBatchFileSort());
  }, []);

  return (
    <ModularHost>
      <ToolbarHeader title="Genelco Batch File Management">
        <ExportToolbarHeaderIcon
          title="Genelco Batch File Management"
          downloadedFileName="GenelcoBatchFileManagement"
          extension={FileExtension.CSV}
          relativeFileLocation={`/enrollmentFiles/csv${addFilterParameters({
            ...genelcoBatchFileFilters,
            exportToCsv: true,
          })}`}
          totalRecordCount={0}
        />
      </ToolbarHeader>
      <>
        <div className="genelco-batch-files">
          {genelcoBatchFileManagementPage !== null ? (
            <GenelcoBatchFileTable genelcoBatchFileMetaData={genelcoBatchFileManagementPage} />
          ) : (
            <Paper className="genelco-batch-file-dropzone">
              <Grid
                className="dropzone__enrollment__grid"
                container
                spacing={4}
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Grid item xs={12} lg={5} md={6}>
                  <div className="genelco-batch-file-dropzone__file-input">
                    <div className="genelco-batch-file-dropzone__image" />

                    <h3 className="genelco-batch-file-dropzone__title">No Batch Files</h3>

                    <Typography className="genelco-batch-file-dropzone__content" variant="body2" color="initial">
                      No Batch Files.
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Paper>
          )}
        </div>
      </>
    </ModularHost>
  );
};

export default GenelcoBatchFileManagementPage;
